import { useNavigate } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import { XCircle, ArrowLeft } from "lucide-react";

import { _t } from "@/lib/i18n";
export default function VoucherCancel() {
  const nav = useNavigate();
  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto py-16 text-center">
        <XCircle className="w-14 h-14 text-yellow-400 mx-auto mb-6" />
        <h1 className="font-display text-4xl text-white mb-3">{_t("Pagamento annullato")}</h1>
        <p className="text-white/60 mb-8">{_t("Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.")}</p>
        <button onClick={() => nav("/dashboard")} className="btn-ghost"><ArrowLeft className="w-4 h-4" />{" "}{_t("Torna alla dashboard")}</button>
      </div>
    </AppLayout>
  );
}
